import { render } from "./verify-account-banner.vue?vue&type=template&id=cac973a8&scoped=true&ts=true"
import script from "./verify-account-banner.vue?vue&type=script&lang=ts"
export * from "./verify-account-banner.vue?vue&type=script&lang=ts"

import "./verify-account-banner.vue?vue&type=style&index=0&id=cac973a8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cac973a8"]])

export default __exports__